export default __webpack_public_path__ + "static/media/feedbackIcon.8130dc04.svg";